import { User, UUID, CommonGlobalService } from '@umanforge/common';
import { DEFAULT_BACKLOG } from 'constants/eventManager.constant';

export interface Sector {
  id: string;
  name: string;
  isAdmin: boolean;
}
export interface Site {
  id: string;
  name: string;
  isAdmin: boolean;
  sectors?: Sector[];
}
export interface Client {
  id: string;
  name: string;
  isAdmin: boolean;
  sites?: Site[];
}

export function isTableAdmin(
  participants: Array<{ userId: string; isAdmin: boolean }>,
  myUserId?: string
): boolean {
  return (
    Array.isArray( participants ) &&
    participants.some ( p => { return p.userId === myUserId && p.isAdmin; } )
  );
}

const isAdminOfEventManagerOrHiger = ( connectedUser: User | null, sectorOfEventManagerId?: UUID, isAdminOfEventManager?: boolean ) => {
  return (
    isAdminOfEventManager === true ||
    ( connectedUser != null && sectorOfEventManagerId != null && CommonGlobalService.isAdminOfSector( connectedUser, sectorOfEventManagerId ) )
  );
};
const isParticipantOnEngagement = ( connectedUser: User | null, engagement?: { participants: string[] | Array<{ userId?: string; isAdmin?: boolean }> } ) => {
  return (
    connectedUser != null &&
    engagement != null &&
    engagement.participants.some( ( item: ( { userId?: UUID; isAdmin?: boolean } | UUID ) ) => {
      let isOnEngagement = false;
      if ( typeof item === 'string' ) {
        isOnEngagement = item === connectedUser?.id;
      } else {
        isOnEngagement = item.userId === connectedUser?.id;
      }
      return isOnEngagement;
    } )
  );
};
const isAloneBackLogOnEngagement = ( connectedUser: User | null, engagement?: { participants: string[] | Array<{ userId?: string; isAdmin?: boolean }> } ) => {
  return (
    connectedUser != null &&
    engagement != null &&
    engagement.participants.length === 1 &&
    engagement.participants.some( ( item: ( { userId?: UUID; isAdmin?: boolean } | UUID ) ) => {
      let isOnEngagement = false;
      if ( typeof item === 'string' ) {
        isOnEngagement = item === DEFAULT_BACKLOG.ID;
      } else {
        isOnEngagement = item.userId === DEFAULT_BACKLOG.ID;
      }
      return isOnEngagement;
    } )
  );
};

export function checkUserParticipation(
  connectedUser: User | null, sectorOfEventManagerId?: UUID, isAdminOfEventManager?: boolean,
  engagements?: Array<{ participants: string[] | Array<{ userId?: string; isAdmin?: boolean }> }>
): boolean {
  let isAuthorized = false;

  isAuthorized = isAdminOfEventManagerOrHiger( connectedUser, sectorOfEventManagerId, isAdminOfEventManager );

  if ( !isAuthorized && Array.isArray( engagements ) && connectedUser?.id ) {
    isAuthorized = engagements.some( engagement => {
      const isUserEngagedOnEng = isParticipantOnEngagement( connectedUser, engagement );
      const isBackLogEngagedAloneOnEng = isAloneBackLogOnEngagement( connectedUser, engagement );

      return isUserEngagedOnEng || isBackLogEngagedAloneOnEng;
    } );
  }

  return isAuthorized;
}